import LoginDesktopView from "./desktop/Login.desktop.view";
import LoginMobileView from "./mobile/Login.mobile.view";
import { useIsDesktopDevice } from "../../tools/hooks/useIsDesktopDevice.ts";
import { useIsMobileDevice } from "../../tools/hooks/useIsMobileDevice.ts";

export default function LoginView() {
  const isDesktop = useIsDesktopDevice();
  const isMobile = useIsMobileDevice();

  return (
    <>
      {isMobile && <LoginMobileView />}
      {isDesktop && <LoginDesktopView />}
    </>
  );
}
